<template>
  <v-card class="mx-auto mb-2">
    <v-card-title class="title justify-space-between"
      >{{ title }}
      <slot name="button"></slot>
    </v-card-title>
    <v-card-text>
      <slot></slot>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "Card",
  props: ["title"]
};
</script>
